import { render, staticRenderFns } from "./recruitment-list-sort.vue?vue&type=template&id=f3650996"
import script from "./recruitment-list-sort.vue?vue&type=script&lang=js"
export * from "./recruitment-list-sort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports